import { render, staticRenderFns } from "./JgpTreeItem.vue?vue&type=template&id=a844a012&"
import script from "./JgpTreeItem.vue?vue&type=script&lang=js&"
export * from "./JgpTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports